import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Carousel, Spinner } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaArrowRight, FaInstagram, FaPlay } from 'react-icons/fa';
import CustomerReviews from './CustomerReviews';
import FAQTabs from './FAQTabs';
import PaymentCalculator from '../components/PaymentCalculator';
import SalesSystem from './SalesSystem';

const HomePage = () => {
    const location = useLocation();

    // Carousel kontrolü için state
    const [index, setIndex] = useState(0);

    // Instagram Reels için state
    const [instagramReels, setInstagramReels] = useState([]);
    const [loadingReels, setLoadingReels] = useState(false);

    // Instagram Reels yükle
    const fetchInstagramReels = async () => {
        setLoadingReels(true);
        try {
            // Bu örnekte mock data kullanıyoruz - gerçek implementasyonda 
            // Instagram Graph API veya güvenli bir backend endpoint kullanılmalı
            const mockReels = [
                {
                    id: '1',
                    media_url: '/images/reel-thumb-1.jpg',
                    permalink: 'https://www.instagram.com/otoprimetaksit/reels/',
                    caption: '🚗 Hayalindeki araba artık çok yakın! #otoprime #araç #taksit',
                    thumbnail_url: '/images/reel-thumb-1.jpg'
                },
                {
                    id: '2',
                    media_url: '/images/reel-thumb-2.jpg',
                    permalink: 'https://www.instagram.com/reel/DJtmyOUoH2M/',
                    caption: '✨ 36 aya varan taksit fırsatları! #araçkredi #otoprime',
                    thumbnail_url: '/images/reel-thumb-2.jpg'
                },
                {
                    id: '3',
                    media_url: '/images/reel-thumb-3.jpg',
                    permalink: 'https://www.instagram.com/reel/DJjjAFsyyuX/',
                    caption: '🔥 Bu ay özel kampanyalar! #araç #kampanya #otoprime',
                    thumbnail_url: '/images/reel-thumb-3.jpg'
                },
                {
                    id: '4',
                    media_url: '/images/reel-thumb-4.jpg',
                    permalink: 'https://www.instagram.com/reel/DJ86ik0ygLd/',
                    caption: '🎯 Müşteri yorumları gelmeye devam ediyor! #memnuniyet',
                    thumbnail_url: '/images/reel-thumb-4.jpg'
                }
            ];

            setInstagramReels(mockReels);
        } catch (error) {
            console.error('Instagram reels yükleme hatası:', error);
        } finally {
            setLoadingReels(false);
        }
    };

    // Component yüklendiğinde
    useEffect(() => {
        fetchInstagramReels();

        // URL parametrelerini kontrol et ve gerekirse scroll yap
        const searchParams = new URLSearchParams(location.search);
        const scrollToSection = searchParams.get('scrollTo');

        if (scrollToSection) {
            setTimeout(() => {
                const element = document.getElementById(scrollToSection);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 500); // Sayfanın tam yüklenmesi için biraz beklet
        }
    }, [location]);

    // Carousel index değişikliği
    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    // Carousel öğeleri - Güncellenmiş yazılar
    const carouselItems = [
        {
            id: 1,
            title: "Hayalinizdeki Araba Sadece Birkaç Tık Uzakta!",
            description: "36 aya varan esnek taksit seçenekleriyle istediğiniz aracı hemen alın. Gerekli evrakları tamamladıysanız, işlemleriniz sadece 4 dakikada tamamlanıyor. Hayalinizdeki araca ulaşmak artık çok kolay!",
            buttonText: "Hemen İncele",
            buttonLink: "/sales-system",
            backgroundImage: "/images/car1.jpg"
        },
        {
            id: 2,
            title: "En Kolay Araç Alma Platformu, 4 dakika!",
            description: "Binlerce araç seçeneği, başvurunu yap – onay süreci birkaç saat içinde tamamlanır, ardından satış işlemi sadece 4 dakikada hallolur! Sen beğen, biz hızla teslim edelim.",
            buttonText: "Şimdi Başvur",
            buttonLink: "/application",
            backgroundImage: "/images/car2.jpg"
        },
        {
            id: 3,
            title: "Artık Beklemek Yok! Hemen Sahip Ol!",
            description: "Geleneksel kredi başvurularını unut! Otoprime ile aracın birkaç saat içinde kapında olabilir.",
            buttonText: "Keşfet",
            buttonLink: "/application",
            backgroundImage: "/images/car3.jpg"
        }
    ];

    return (
        <div className="homepage">
            {/* Ana Carousel Bölümü */}
            <div className="main-carousel" id="mainCarousel">
                <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                    interval={5000}
                    controls={true}
                    indicators={true}
                    className="split-carousel"
                >
                    {carouselItems.map((item) => (
                        <Carousel.Item key={item.id}>
                            <div
                                className="carousel-content"
                                style={{
                                    backgroundImage: `url(${item.backgroundImage})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                                <Container>
                                    <Row className="align-items-center">
                                        <Col md={6} lg={5} xl={4} className="carousel-text">
                                            <h1>{item.title}</h1>
                                            <p>{item.description}</p>
                                            <Link
                                                to={item.buttonLink}
                                                className="btn btn-elegant-orange"
                                            >
                                                {item.buttonText}
                                                <FaArrowRight className="ms-2" />
                                            </Link>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
                <div className="carousel-indicators-custom">
                    {carouselItems.map((_, idx) => (
                        <button
                            key={idx}
                            className={index === idx ? "active" : ""}
                            onClick={() => setIndex(idx)}
                        />
                    ))}
                </div>
            </div>

            {/* Aylık Ödeme Hesaplama */}
            <section className="payment-calculator-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col md={6}>
                            <div className="calculator-card border-0 shadow-sm">
                                <div className="p-4">
                                    <PaymentCalculator initialAmount={100000} />
                                </div>
                            </div>
                        </Col>
                        <Col md={6} className="d-none d-md-flex flex-column align-items-center justify-content-center">
                            {/* Üst kısım - Yazı */}
                            <div className="calculator-overlay position-relative mb-4">
                                <h3 className="overlay-title">Hızlı Başvuru</h3>
                                <p className="overlay-subtitle">Size ne kadarlık araç bulmamızı istersiniz?</p>
                            </div>
                            {/* Alt kısım - Resim */}
                            <div>
                                <img
                                    src="/images/hesaplama.jpg"
                                    alt="Ödeme Hesaplama"
                                    className="img-fluid calculator-image"
                                    style={{ maxHeight: '400px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Nasıl Çalışır Bölümü */}
            <SalesSystem
                showBanner={false}
                showStepsTitle={true}
                showAdvantages={false}
                showFAQ={false}
                showCTA={false}
            />

            {/* Müşteri Yorumları */}
            <CustomerReviews />

            {/* Otoprime Hakkında - SSS Bölümü */}
            <FAQTabs
                showTitle={true}
                title="Sorularla Otoprime'i Tanı"
                id="home-faq-section"
                defaultActiveTab="general"
            />

            {/* Instagram Reels Bölümü */}
            <section className="py-5 bg-light">
                <Container>
                    <div className="text-center mb-5">
                        <h2 className="section-title">
                            <FaInstagram className="me-3" style={{ color: '#E4405F' }} />
                            Instagram'da Bizi Takip Edin
                        </h2>
                        <p className="lead">
                            Güncel kampanyalar, müşteri hikayeleri ve araç önerilerini kaçırmayın!
                        </p>
                        <a
                            href="https://www.instagram.com/otoprimetaksit/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn apply-btn-black mb-4"
                            style={{ textDecoration: 'none' }}
                        >
                            <FaInstagram className="me-2" />
                            @otoprimetaksit
                        </a>
                    </div>

                    {loadingReels ? (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-3">Instagram içerikleri yükleniyor...</p>
                        </div>
                    ) : (
                        <Row className="g-4 justify-content-center">
                            <Col lg={10}>
                                <Row className="g-4">
                                    {instagramReels.map((reel) => (
                                        <Col key={reel.id} lg={3} md={6} sm={6}>
                                            <div className="card h-100 border-0 shadow-sm instagram-card">
                                                <div className="instagram-image-container">
                                                    <img
                                                        src={reel.thumbnail_url}
                                                        alt={reel.caption}
                                                        className="card-img-top"
                                                    />
                                                    <div className="instagram-overlay">
                                                        <a
                                                            href={reel.permalink}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="instagram-play-btn"
                                                        >
                                                            <FaPlay />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="card-body p-3">
                                                    <p className="card-text small text-muted mb-0">
                                                        {reel.caption.length > 60
                                                            ? `${reel.caption.substring(0, 60)}...`
                                                            : reel.caption
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    )}

                    <div className="text-center mt-5">
                        <a
                            href="https://www.instagram.com/otoprimetaksit/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn apply-btn-black btn-lg"
                        >
                            <FaInstagram className="me-2" />
                            Daha Fazla İçerik İçin Takip Et
                        </a>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default HomePage;